import { Apollo } from 'src/gql/generated';

type OnboardingTasks = NonNullable<
  NonNullable<Apollo.GetMyOnboardingInfoQueryResult['data']>['currentUser']
>['settings']['onboardingTasks'];

export function useMyOnboardingInfoQuery(): { loading: boolean; onboardingTasks: OnboardingTasks } {
  const { data, loading } = Apollo.useGetMyOnboardingInfoQuery();
  return { loading, onboardingTasks: data?.currentUser?.settings.onboardingTasks ?? [] };
}
